import { FC } from "react";
import { Avatar, Badge, Card, CardBody, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { Shimmer } from "@am-tax/fe-core";
import { UserTenantResponse } from "../../api";
import { WidgetHeading } from "./WidgetHeading";

const AVATAR_COLORS = ["blue", "teal", "green", "purple", "orange", "cyan", "pink", "red"];

function getAvatarColor(name: string): string {
    let hash = 0;
    for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + hash * 31;
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

const ROLE_COLOR_SCHEME: Record<string, string> = {
    Owner: "purple",
    Contributor: "blue",
    Reader: "gray",
    Limited: "orange",
};

type UsersWidgetProps = {
    isLoading: boolean;
    users: UserTenantResponse[] | undefined;
    clientId: string | undefined;
};

export const UsersWidget: FC<UsersWidgetProps> = ({ isLoading, users, clientId }) => {
    return (
        <Card width={"100%"} height={"100%"} variant={"withShadow"}>
            <CardBody px={"1.25rem"} pt={"1rem"} pb={"1.25rem"}>
                <WidgetHeading title="Users" url={clientId ? `/admin/clients/${clientId}/access` : undefined} />
                <Shimmer isLoading={isLoading}>
                    <TableContainer whiteSpace="unset" maxHeight="360px" overflowY="auto">
                        <Table variant="simple" size="sm">
                            <Thead position="sticky" top={0} bg="white" zIndex={1}>
                                <Tr>
                                    <Th></Th>
                                    <Th>Name</Th>
                                    <Th>Role</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {(users || []).map((user: UserTenantResponse, index: number) => (
                                    <Tr key={index} _hover={{ bg: "gray.50" }}>
                                        <Td w="40px" pr={0}>
                                            <Avatar
                                                size="xs"
                                                name={user.userDisplayName}
                                                colorScheme={getAvatarColor(user.userDisplayName || "")}
                                                bg={`${getAvatarColor(user.userDisplayName || "")}.100`}
                                                color={`${getAvatarColor(user.userDisplayName || "")}.700`}
                                            />
                                        </Td>
                                        <Td style={{ wordBreak: "break-word", whiteSpace: "normal" }}>{user.userDisplayName}</Td>
                                        <Td style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
                                            <Badge borderRadius="full" colorScheme={ROLE_COLOR_SCHEME[user.role] ?? "gray"}>
                                                {user.role}
                                            </Badge>
                                        </Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>
                </Shimmer>
            </CardBody>
        </Card>
    );
};
